import { Serializers } from "@megaron/serializers";

import { configField } from "./makeConfig";

const envs = ["production", "test", "development"] as const;
export const nodeEnvConfigField = configField<(typeof envs)[number]>({}, Serializers.stringOneOf(...envs));
